import React from 'react';
import cx from 'classnames';
import styles from './TransitionPage.scss';
import transitions from '../transitions.scss';
import PlaceholderIcon from '../../../../../modules/react/components/stateless/PlaceholderIcon';

const Link = ({ href, target, title }) => {
  const sharedClasses = cx(
    styles.singleLink,
    styles.height,
    styles.linkText,
  );
  return (
    <a
      className={cx(sharedClasses, styles.externalLink)}
      href={href}
      target={target}
    >
      {title}
    </a>
  );
};

const getContainerStyles = ({ visible, transition, direction, isBase, isDesktop }) => {
  if (!isDesktop) {
    return cx(visible && transitions[`${transition}TransitionIn`], !visible && transitions[`${transition}TransitionOut`]);
  }

  if (isBase) {
    return cx(visible && transitions.noneTransitionIn, !visible && transitions.delayTransitionOut);
  }

  if (direction === 'forwards') {
    return cx(visible && transitions[`${transition}TransitionIn`], !visible && transitions.delayTransitionOut);
  }

  if (direction === 'back') {
    return cx(visible && transitions.delayTransitionIn, !visible && transitions[`${transition}TransitionOut`]);
  }

  return cx();
};

const TransitionPage = ({
  page: { items, path },
  visible,
  transition,
  addToStack,
  isDesktop,
  stackTitle,
  toggleBack,
  index,
  direction,
}) => {
  const isBase = index === 0;
  const containerStyles = getContainerStyles({ visible, transition, direction, isBase, isDesktop });
  return (
    <div className={cx(styles.transitionPage, { zIndex: 1001 + index })}>
      <div className={containerStyles}>
        {isDesktop && stackTitle && !isBase && (
          <div className={styles.titleDiv}>
            <button type="button" className={styles.backButton} onClick={() => toggleBack()}>
              <PlaceholderIcon.LeftChevron />
            </button>
            <span className={styles.title}>{stackTitle}</span>
            <div />
          </div>
        )}
        {items.map((item) => {
          const linkName = item.text || item.page?.title;
          const linkPath = item.link?.href || item.page?.path;

          if (item.navigationItems && item.navigationItems.length) {
            return (
              <div
                className={styles.pageComponent}
                key={item.id}
                onClick={() => addToStack(`${path}${path === '/' ? '' : '/'}${linkName}`)}
                aria-hidden="true"
              >
                <Link href={linkPath} target={item.link?.target} title={linkName} />
                <button className={styles.navButton} type="button">
                  <PlaceholderIcon.RightChevron />
                </button>
              </div>
            );
          }

          return (
        <div className={styles.pageComponent} key={`item-${index}-${item.id}`}>
          <Link href={linkPath} target={item.link?.target} title={linkName} />
        </div>
          );
        })}
      </div>
    </div>
  );
};

export default TransitionPage;
